<template>
	<section>
		<div class="filters">
			<div class="checkbox-filter bg-call" @click="inCallFilter = !inCallFilter">
				<input class="form-control" type="checkbox" name="incall" v-model="inCallFilter">
				<span>Em ligação</span>
			</div>
			<div class="checkbox-filter bg-pause" @click="pausedFilter = !pausedFilter">
				<input class="form-control" type="checkbox" name="paused" v-model="pausedFilter">
				<span>Em pausa</span>
			</div>
			<div class="checkbox-filter bg-not-logged" @click="loggedFilter = !loggedFilter">
				<input class="form-control" type="checkbox" name="not-logged" v-model="loggedFilter">
				<span>Ocultar deslogados</span>
			</div>
			<div class="select-filter bg-status"
				:class="{ 'bg-success': statusFilter === true, 'bg-danger': statusFilter === false, 'bg-secondary': statusFilter === '*' }">
				<span>Status: </span>
				<select class="form-control" v-model="statusFilter">
					<option value="*">Todos</option>
					<option :value="true">Online</option>
					<option :value="false">Offline</option>
				</select>
			</div>
			<input type="text" v-model="keyword" placeholder="🔎  Busque por nome, fila ou ramal..."
				class="form-control">
		</div>
		<div v-if="filteredUsers.length" class="or-users-table-wrapper"
			:class="{ 'module-height': view === 'ModuleView' }">
			<b-table table-class="or-users-table" :items="filteredUsers" :fields="fields" :per-page="perPage"
				:current-page="currentPage" striped hover bordered outlined fixed small responsive sort-by="inCall"
				:sort-desc="true" @filtered="onFiltered">
				<template #cell(name)="data">
					<span v-if="data.item.active == 1" title="Supervisor"><i
							class="fas fa-user text-danger"></i><strong> {{
								data.item.name }}</strong></span>
					<span v-if="data.item.active == 2" title="Operador"><i class="fas fa-user text-primary"></i><strong>
							{{
								data.item.name }}</strong></span>
				</template>
				<template #cell(extension_line)="data">
					<strong>{{ data.item.extension_line }}</strong>
				</template>
				<template #cell(queues)="data">
					<div v-if="data.item.queues.length">
						<span v-for="q in data.item.queues.slice(0, 5)" :key="q.name" class="badge custom-queue-badge"
							:class="{ 'bg-pause cursor-help': q.status === 'paused' }"
							:title="q.status === 'paused' ? `${q.pauseReason} ● ${secondsToString(q.lastPause)}` : 'Ativo na fila'">
							<i v-if="q.status === 'paused'" class="fas fa-pause"></i>
							<i v-else class="fas fa-play"></i>
							<span class="bg-active" :class="{
								'bg-pause': q.status === 'paused',
								'queue-alias-autoscroll': getQueueAlias(q.name).length > 17
							}" :style="getScrollStyle(q.name)">
								{{ getQueueAlias(q.name) }}
							</span>
						</span>

						<span v-if="data.item.queues.length > 5" class="badge custom-queue-badge bg-secondary"
							:title="getExtraQueuesTitle(data.item.queues)">
							<i class="fas fa-plus"></i>
							<span>{{ data.item.queues.length - 5 }}</span>
						</span>
					</div>
					<div v-else>
						<span class="badge custom-queue-badge" style="background-color: gray;">Deslogado</span>
					</div>
				</template>
				<template #cell(status)="data">
					<span v-if="data.item.status" class="text-success">
						<i class="fas fa-circle text-success fa-beat-fade icon-extension-status"
							style="--fa-animation-duration: 1.5s;"></i><strong>Online</strong>
					</span>
					<span v-else class="text-danger">
						<i class="fas fa-circle text-danger icon-extension-status"></i><strong>Offline</strong>
					</span>
				</template>
				<template #cell(paused)="data">
					<div v-if="data.item.paused" class="paused">
						<i class="fas fa-pause"></i> {{ data.item.pauseReason }} ● {{ secondsToTime(data.item.lastPause)
						}}
					</div>
					<div v-else class="unpaused">
						<i class="fas fa-play"></i> Ativo
					</div>
				</template>
				<template #cell(inCall)="data">
					<div v-if="data.item.inCall" class="incall">
						<div class="call-info">
							<div v-if="data.item.callStatus === 'active'" class="call-icons">
								<div v-if="data.item.callType === 'incoming'" title="Ligação entrante - em curso">
									<i class="fas fa-phone text-success"></i>
									<i class="fas fa-arrow-down text-success"></i>
								</div>
								<div v-else-if="data.item.callType === 'outgoing'" title="Ligação sainte - em curso">
									<i class="fas fa-phone text-danger"></i>
									<i class="fas fa-arrow-up text-danger"></i>
								</div>
							</div>
							<div v-else-if="data.item.callStatus === 'ringing'" class="call-icons">
								<div v-if="data.item.callType === 'incoming'" title="Ligação entrante - Tocando">
									<i class="fas fa-volume-control-phone fa-beat-fade ringing-icon"></i>
									<i class="fas fa-arrow-down fa-beat-fade ringing-icon"></i>
								</div>
								<div v-else-if="data.item.callType === 'outgoing'" title="Ligação sainte - Chamando">
									<i class="fas fa-volume-control-phone fa-beat-fade ringing-icon"></i>
									<i class="fas fa-arrow-up fa-beat-fade ringing-icon"></i>
								</div>
							</div>
							{{ data.item.callNumber }}
						</div>
						{{ secondsToTime(data.item.callDuration) }}
					</div>
					<div v-else class="available">
						<i class="fas fa-phone"></i> Disponível
					</div>
				</template>
				<template #cell(action)="data">
					<!-- <div>{{ data.item }}</div> -->
					<div class="action-container">
						<div v-if="data.item.queues.length" id="logout-button" title="Deslogar"
							@click="logoff(data.item.extension_line, data.item.queues)"><i class="fas fa-power-off"></i>
						</div>
						<div v-else id="login-button" title="Logar"
							@click="login(data.item.extension_line, data.item.user_queues)"><i
								class="fas fa-power-off"></i></div>
						<div id="pause-button" title="Gerenciar pausas"
							:class="{ 'disabled-button': !data.item.queues.length }"
							@click="openDetailsModal(data.item, !data.item.queues.length)"><i class="fas fa-pause"></i>
						</div>
						<div id="hangup-button" title="Desligar ligação"
							:class="{ 'disabled-button': !data.item.inCall }"
							@click="hangup(data.item.channel, !data.item.inCall)"><i class="fas fa-times"></i></div>
						<div id="pickup-button" title="Puxar ligação"
							:class="{ 'disabled-button': data.item.callType !== 'incoming' || data.item.callStatus !== 'ringing' }"
							@click="pickup(data.item.extension_line, data.item.channel, (data.item.callType !== 'incoming' || data.item.callStatus !== 'ringing'))">
							<i class="fas fa-reply"></i>
						</div>
						<div id="spy-button" title="Escutar"
							:class="{ 'disabled-button': !data.item.inCall || data.item.callStatus === 'ringing' }"
							@click="spy(data.item.extension_line, (!data.item.inCall || data.item.callStatus === 'ringing'))">
							<i class="fas fa-headphones"></i>
						</div>
						<div id="whisper-button" title="Sussurrar"
							:class="{ 'disabled-button': !data.item.inCall || data.item.callStatus === 'ringing' }"
							@click="whisper(data.item.extension_line, (!data.item.inCall || data.item.callStatus === 'ringing'))">
							<i class="fas fa-microphone"></i>
						</div>
					</div>
				</template>
			</b-table>
		</div>
		<div v-else :class="{ 'module-height': view === 'ModuleView' }">
			<div v-if="!reconnection" class="alert alert-warning">Não há usuários para exibir</div>
			<div v-else class="alert alert-danger">Reconectando ao serviço do Realtime...</div>
		</div>
		<div class="table-footer">
			<div class="per-page-selector">
				<span>Registros por página: </span>
				<select class="form-control" v-model="perPage">
					<option value="10">10</option>
					<option value="30">30</option>
					<option value="50">50</option>
					<option value="70">70</option>
					<option value="100">100</option>
				</select>
			</div>
			<b-pagination v-if="filteredUsers.length" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
				align="right" size="md" class="my-0"></b-pagination>
		</div>
	</section>
</template>

<script>
// @ts-nocheck
export default {
	name: 'OrUsersTable',
	props: [
		'usersList',
		'queueList',
		'currentCalls',
		'peersStatus',
		'queueMembers',
		'socketClient',
		'reconnection',
		'enabledListeners',
		'view'
	],
	data() {
		return {
			
			fields: [
				{ key: 'name', label: 'Nome', sortable: true, 'thClass': 'or-custom-header', tdClass: 'align-content-center' },
				{ key: 'extension_line', label: 'Ramal', sortable: true, 'thClass': 'or-custom-header small-column', tdClass: 'text-center fw-bold align-content-center' },
				{ key: 'status', label: 'Status', sortable: true, 'thClass': 'or-custom-header small-column', tdClass: 'text-center  align-content-center' },
				{ key: 'queues', label: 'Filas', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center  align-content-center' },
				{ key: 'inCall', label: 'Ligação', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center  align-content-center' }
			],
			perPage: this.view === 'OperatorView' ? 10 : 30,
			currentPage: 1,
			totalRows: 0,
			keyword: '',
			inCallFilter: false,
			pausedFilter: false,
			loggedFilter: false,
			statusFilter: '*',
			callTimer: null,
			pauseTimer: null,
			realtimeUsers: []
		};
	},
	computed: {
		filteredUsers() {
			let filteredUsers = this.updatedUsers;

			let appliedFilters = [];

			if (this.statusFilter !== '*') {
				appliedFilters.push(user => user.status === this.statusFilter);
			}

			if (this.inCallFilter) {
				appliedFilters.push(user => user.inCall);
			}

			if (this.pausedFilter) {
				appliedFilters.push(user => user.queues.some(el => el.status === 'paused'));
			}

			if (this.loggedFilter) {
				appliedFilters.push(user => user.queues.length);
			}

			if (appliedFilters.length > 0) {
				filteredUsers = filteredUsers.filter(user =>
					appliedFilters.every(condition => condition(user))
				);
			}

			if (this.keyword) {
				const keyword = this.keyword.trim().toLowerCase();
				filteredUsers = filteredUsers.filter(user => {
					const matchesName = user.name?.toLowerCase().includes(keyword);
					const matchesExtension = user.extension_line?.toString().includes(keyword);

					const matchesQueues = user.queues.some(q => {
						const queue = this.queueList.find(ql => ql.name?.toLowerCase() === q.name?.toLowerCase());
						const alias = queue?.alias?.toLowerCase() || '';
						return alias.includes(keyword);
					});

					return matchesName || matchesExtension || matchesQueues;
				});
			}

			return filteredUsers;
		},
		updatedUsers() {
			return this.realtimeUsers;
		},

		updatedUsersMap() {
			const map = new Map();
			this.realtimeUsers.forEach(user => {
				map.set(parseInt(user.extension_line), user);
			});
			return map;
		}
	},
	mounted() {
		this.totalRows = this.updatedUsers.length;
		if (this.view === 'ModuleView') {
			this.fields.push({ key: 'action', label: 'Ações', sortable: false, 'thClass': 'or-custom-header small-column', tdClass: 'text-center align-content-center' })
		}
	},
	watch: {
		usersList: {
			immediate: true,
			deep: true,
			handler(value) {
				this.realtimeUsers = value.map(el => ({
					...el,
					status: false,
					paused: false,
					inCall: false,
					callDuration: null,
					callNumber: null,
					callType: null,
					callStatus: null,
					channel: null,
					queues: []
				}));

				this.$nextTick(() => {
					this.peersStatus.forEach(el => {
						this.handleStatusUpdate(el);
					});
				});
			}
		},

		filteredUsers() {
			this.totalRows = this.filteredUsers.length;
		},
		peersStatus: {
			handler(value) {
				if (value.length) {
					value.forEach(el => {
						this.handleStatusUpdate(el);
					});
				}
			},
			deep: true
		},

		queueMembers: { //Filas do ramal e pausa - Dados da requisiçao "queue-member"
			handler(value) {
				if (value.length) {
					value.map(el => {
						const found = this.updatedUsers.find(usr => usr.extension_line == el.extension_line)
						if (found) {
							if (!found.queues.some(q => q.name === el.queue)) found.queues.push({ name: el.queue, status: 'logged' })
							if (el.paused) {
								found.paused = true
								const pauseReason = !el.pause_reason ? 'Pausa no ramal' : el.pause_reason
								const lastPause = el.last_pause
								if (found.queues.length) {
									found.queues.map(fq => {
										if (fq.name === el.queue) {
											fq.status = 'paused'
											fq.pauseReason = pauseReason
											fq.lastPause = parseInt(lastPause)
										}
									})
								}
							}
						}
					})
					this.$nextTick(async () => {
						this.calcPauseTimer()
					});
				}
			},
			deep: true
		},
		currentCalls: { //Ligações em curso - Dados da requisiçao "core-show-channels"`
			handler(value) {
				if (value.length) {
					value.map(async el => {
						await this.handleCall(el)
					})
					this.$nextTick(async () => {
						this.calcCallTimer()
					});
				}
			},
			deep: true
		},
		"enabledListeners.currentCalls": {
			handler(value) {
				if (value) this.enableListeners('currentCalls')
			}
		},
		"enabledListeners.queueMembers": {
			handler(value) {
				if (value) this.enableListeners('queueMembers')
			}
		},
		"enabledListeners.peerStatus": {
			handler(value) {
				if (value) this.enableListeners('peerStatus')
			}
		},
	},
	methods: {
		getQueueAlias(queueName) {
			const match = this.queueList.find(q => q.name?.toLowerCase() === queueName?.toLowerCase());
			return match?.alias || queueName;
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		secondsToTime(seconds) {
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;

			const pad = (num) => String(num).padStart(2, '0');

			return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
		},
		secondsToString(unixTimestamp) {
			const now = moment();
			const pauseTime = moment.unix(unixTimestamp);
			const duration = moment.duration(now.diff(pauseTime));

			const totalMinutes = Math.floor(duration.asMinutes());

			if (totalMinutes < 1) return "Há menos de um minuto";

			if (totalMinutes < 60) {
				return `Há mais de ${totalMinutes} minuto${totalMinutes > 1 ? "s" : ""}`;
			}

			const hours = Math.floor(totalMinutes / 60);
			const remainingMinutes = totalMinutes % 60;

			if (remainingMinutes === 0) {
				return `Há mais de ${hours} hora${hours > 1 ? "s" : ""}`;
			}

			return `Há mais de ${hours} hora${hours > 1 ? "s" : ""} e ${remainingMinutes} minuto${remainingMinutes > 1 ? "s" : ""}`;
		},
		timeToSeconds(time) {
			const [hours, minutes, seconds] = time.split(':').map(num => parseInt(num, 10));
			return (hours * 3600) + (minutes * 60) + seconds;
		},
		calcPauseTimer() {
			clearInterval(this.pauseTimer);
			this.pauseTimer = setInterval(() => {
				this.updatedUsers.map((el) => {
					if (el.queues.length) {
						if (el.queues.some(el => el.status === 'paused')) {
							el.queues.map(q => {
								if (q.status === 'paused') {
									this.$forceUpdate();
								}
							})
						}
					}
				})
			}, 60000)
		},
		calcCallTimer() {
			clearInterval(this.callTimer);
			this.callTimer = setInterval(() => {
				this.updatedUsers.map((el) => {
					if (el.inCall) el.callDuration++
				})
			}, 1000)
		},
		async enableListeners(type) {
			if (!this.socketClient) return

			if (type === 'currentCalls') {
				this.socketClient.removeAllListeners('ringingCall');
				this.socketClient.removeAllListeners('callInProgress');
				this.socketClient.removeAllListeners('hangup');

				this.socketClient.on('ringingCall', async (data) => {
					console.log('[SOCKET ringingCall]', data);
					await this.handleCall(data);
					this.calcCallTimer();
					this.$forceUpdate();
				})

				this.socketClient.on('callInProgress', async (data) => {
					console.log('[SOCKET callInProgress]', data);
					await this.handleCall(data);
					this.calcCallTimer();
					this.$forceUpdate();
				})

				this.socketClient.on('hangup', async (data) => {
					console.log('[SOCKET hangup]', data);
					await this.handleHangup(data);
					this.$forceUpdate();
				})
			}

			if (type === 'queueMembers') {
				this.socketClient.removeAllListeners('agentQueueLogin');
				this.socketClient.removeAllListeners('agentQueueLogoff');
				this.socketClient.removeAllListeners('agentPause');
				this.socketClient.removeAllListeners('agentUnpause');
				this.socketClient.removeAllListeners('agentDnd');

				this.socketClient.on('agentQueueLogin', async (data) => {
					await this.handleLoginLogoff(data, 'login')
				})

				this.socketClient.on('agentQueueLogoff', async (data) => {
					await this.handleLoginLogoff(data, 'logoff')
				})

				this.socketClient.on('agentPause', async (data) => {
					await this.handlePause(data, 'pause')
				})

				this.socketClient.on('agentUnpause', async (data) => {
					await this.handlePause(data, 'unpause')
				})

				this.socketClient.on('agentDnd', async (data) => {
					// await this.handleEvent('agentDnd', data)
				})
			}

			if (type === 'peerStatus') {
				this.socketClient.removeAllListeners('peerStatusUpdate');
				this.socketClient.on('peerStatusUpdate', async (data) => {
					console.log('[SOCKET peerStatusUpdate]', data);
					await this.handleStatusUpdate(data);
					this.$forceUpdate();
				})
			}
		},
		async handleCall(data) {
			if (data.type === 'outgoing') { // Chamadas saintes - atualizar no ramal de origem
				const user = this.updatedUsersMap.get(parseInt(data.origin));
				if (user) {
					user.inCall = true
					user.callNumber = data.destiny
					user.callType = data.type
					user.callStatus = data.status
					user.callDuration = this.timeToSeconds(data.duration)
					user.channel = data.channel
				}
			} else if (data.type === 'incoming') {
				const user = this.updatedUsersMap.get(parseInt(data.destiny));

				if (user) {
					this.$set(user, 'inCall', true)
					this.$set(user, 'callNumber', data.origin)
					this.$set(user, 'callType', data.type)
					this.$set(user, 'callStatus', data.status)
					this.$set(user, 'callDuration', this.timeToSeconds(data.duration))
					this.$set(user, 'channel', data.channel)
				}
		

			} else if (data.type === 'intercom') { // Chamadas ramal x ramal - atualizar nos dois
				const userOrigin = this.updatedUsersMap.get(parseInt(data.origin));
				const userDestiny = this.updatedUsersMap.get(parseInt(data.destiny));

				if (userOrigin) {
					userOrigin.inCall = true
					userOrigin.callNumber = data.destiny
					userOrigin.callType = 'outgoing'
					userOrigin.callStatus = data.status
					userOrigin.callDuration = this.timeToSeconds(data.duration)
					userOrigin.channel = data.channel
				}

				if (userDestiny) {
					userDestiny.inCall = true
					userDestiny.callNumber = data.origin
					userDestiny.callType = 'incoming'
					userDestiny.callStatus = data.status
					userDestiny.callDuration = this.timeToSeconds(data.duration)
					userDestiny.channel = data.channel
				}
			}
		},
		async handleHangup(data) {
			const user = this.updatedUsersMap.get(parseInt(data.extension));

			if (user && user.inCall) {
				user.inCall = false
				user.callNumber = null
				user.callType = null
				user.callStatus = null
				user.callDuration = null
				user.channel = null
			}
		},
		async handleLoginLogoff(data, type) {
			const user = this.updatedUsersMap.get(parseInt(data.extension));
			let findQueue;
			if (user) {
				if (user.queues.length) findQueue = user.queues.find(q => q.name === data.queue)

				if (type === 'login') {
					if (!findQueue) user.queues.push({ name: data.queue, status: 'logged' })
				} else {
					if (findQueue) {
						user.paused = false;
						const index = user.queues.findIndex(q => q.name === data.queue);
						if (index !== -1) user.queues.splice(index, 1);
					}
				}
			}
		},
		async handlePause(data, type) {
			const user = this.updatedUsersMap.get(parseInt(data.extension));
			let findQueue;
			if (user) {
				if (user.queues.length) findQueue = user.queues.find(q => q.name === data.queue)
				if (type === 'pause') {
					user.paused = true;
					if (findQueue) {
						const pauseReason = !data.reason ? 'Pausa no ramal' : data.reason
						const lastPause = 0
						findQueue.status = 'paused'
						findQueue.pauseReason = pauseReason
						findQueue.lastPause = moment().unix()
					}
				} else {
					if (findQueue) {
						findQueue.status = 'logged'
						delete findQueue.pauseReason;
						delete findQueue.lastPause;
					}
					// Mantém usuário pausado caso ainda exista outra fila em pausa.
					const hasOtherPausedQueues = user.queues.some(q => q.status === 'paused');
					user.paused = hasOtherPausedQueues;
				}
			}
		},
		async handleStatusUpdate(data) {
			const extension = data.extension_line || data.extension;

			const user = this.updatedUsers.find(usr =>
				String(usr.extension_line) === String(extension)
			);

			console.log('[HANDLE STATUS UPDATE]', {
				recebido: data,
				extension,
				achouUsuario: !!user
			});

			if (user) {
				this.$set(user, 'status', data.status);
				this.$forceUpdate();
			}
		},
		
		calculateScrollOffset(text) {
			if (text.length <= 17) return 0;

			// Criar elemento temporário para medir
			const tempSpan = document.createElement('span');
			tempSpan.style.visibility = 'hidden';
			tempSpan.style.position = 'absolute';
			tempSpan.style.whiteSpace = 'nowrap';
			tempSpan.style.font = '14px Arial'; // Ajuste para sua fonte
			tempSpan.textContent = text;

			document.body.appendChild(tempSpan);
			const textWidth = tempSpan.offsetWidth;
			document.body.removeChild(tempSpan);

			const containerWidth = 110; // seu max-width
			const overflow = textWidth - containerWidth;

			return overflow > 0 ? Math.min((overflow / textWidth) * 90, 70) : 0;
		},
		getScrollStyle(queueName) {
			const alias = this.getQueueAlias(queueName);
			if (alias.length <= 17) return {};

			const offset = this.calculateScrollOffset(alias);
			const style = {
				'--scroll-offset': `-${offset}%`,
			};

			return style;
		},
		getExtraQueuesTitle(queues) {
			const extraQueues = queues.slice(5);
			let pauseInfo;
			let status = '▶️';
			const queueInfo = extraQueues.map(q => {
				const alias = this.getQueueAlias(q.name);
				if (q.status !== 'paused') {
					return `${status} ${alias}`;
				}
				else {
					status = '⏸️';
					pauseInfo = `${q.pauseReason} ● ${this.secondsToString(q.lastPause)}`
					return `${status} ${alias} - ${pauseInfo}`;
				}
			});
			return `${extraQueues.length} filas adicionais:\n${queueInfo.join('\n')}`;
		},
		login(extension_line, queues, disabled = false) {
			if (disabled || !queues.length) return;
			queues = queues.map(el => el.name)
			this.$emit('emitIntermediate', { payload: { extension_line, queues }, event: 'login' })
		},
		async logoff(extension_line, queues, disabled = false) {
	if (disabled || !queues.length) return;
	
	const pausedQueues = queues.filter(q => q.status === 'paused');
	
	if (pausedQueues.length > 0) {
		const user = this.updatedUsers.find(u => u.extension_line === extension_line);
		
		if (user) {
			// *** COLETA TODAS AS FILAS PAUSADAS ***
			const pausedQueueNames = pausedQueues.map(q => q.name);
			
			console.log(`[LOGOFF] Registrando retorno de pausas - Usuário ${user.id} - Filas: ${pausedQueueNames.join(', ')}`);
			
			// *** UMA ÚNICA REQUISIÇÃO COM TODAS AS FILAS ***
			await axios.post(`${location.origin}/api/setOperatorPauseRealtime`, {
				user_id: user.id,
				pause_reason: 'retorno',
				queues: pausedQueueNames, // Array com todas as filas pausadas
				pause_end: moment().format('YYYY-MM-DD HH:mm:ss')
			}).catch(err => {
				console.error('Erro ao registrar saída de pausa no logoff:', err);
			});
		}
	}
	
	const queueNames = queues.map(el => el.name);
	this.$emit('emitIntermediate', { payload: { extension_line, queues: queueNames }, event: 'logoff' });
},
		hangup(channel, disabled = false) {
			if (disabled || !channel) return;
			this.$emit('emitIntermediate', { payload: { channel }, event: 'hangup' })
		},
		pickup(extension_line, disabled = false) {
			const operator_extension = user.getExtension()
			if (disabled || operator_extension === extension_line) return;
			this.$emit('emitIntermediate', { payload: { extension_line, operator_extension }, event: 'pickup' })
		},
		spy(extension_line, disabled = false) {
			const operator_extension = user.getExtension()
			if (disabled || operator_extension === extension_line) return;
			this.$emit('emitIntermediate', { payload: { extension_line, operator_extension }, event: 'spy' })
		},
		whisper(extension_line, disabled = false) {
			const operator_extension = user.getExtension()
			if (disabled || operator_extension === extension_line) return;
			this.$emit('emitIntermediate', { payload: { extension_line, operator_extension }, event: 'whisper' })
		},
		openDetailsModal(user, disabled = false) {
			if (disabled) return
			this.$emit('open-details-modal', { user, mode: 'manage' })
		}
	},
};
</script>

<style lang="scss" scoped>
.filters {
	margin: 15px;
	display: flex;
	gap: 20px;

	.checkbox-filter {
		display: flex;
		gap: 5px;
		border-radius: 10px;
		padding: 0 5px;
		box-shadow: 1px 1px 3px gray;
		cursor: pointer;
		transition: 0.3s;

		input {
			cursor: pointer;
			height: 100%;

			&:focus {
				outline: none;
				box-shadow: none;
			}
		}

		span {
			font-weight: bold;
			white-space: nowrap;
			align-content: center;
			color: white;
		}

		&:hover {
			filter: brightness(0.8);
		}
	}

	.select-filter {
		min-width: fit-content;
		display: flex;
		gap: 5px;
		border-radius: 10px;
		box-shadow: 1px 1px 3px gray;
		font-weight: bold;
		padding-left: 5px;
		transition: 0.3s;

		select {
			border-radius: 0 10px 10px 0 !important;
			cursor: pointer;
		}

		span {
			font-weight: bold;
			white-space: nowrap;
			align-content: center;
			color: white;
		}
	}


	.bg-pause {
		background-color: #c2b049 !important;
	}

	.bg-call {
		background-color: #2a95b1;
	}

	.bg-not-logged {
		background-color: #b32424 !important;
	}
}

.module-height {
	height: calc(100vh - 220px) !important;
	max-height: unset !important;
}

.or-users-table-wrapper {
	max-height: 68vh;
	overflow-y: auto;
	margin: 10px;

	::v-deep(.table-responsive) {
		border-radius: 10px 10px 0 0;
		box-shadow: 1px 1px 3px 1px #0000001f
	}

	::v-deep(.or-custom-header) {
		font-weight: bold;
		text-align: center;
		background-color: #1c869a;
		color: white
	}

	::v-deep(.small-column) {
		width: 100px;
		text-align: center;
	}

	.icon-extension-status {
		align-self: center;
		margin-right: 5px;
	}

	.custom-queue-badge {
		background-color: #287228;
		border-radius: 5px;
		padding: 2px 5px 2px 5px;
		margin: 2px;
		color: white;
		overflow: hidden;
		max-width: 110px;
		white-space: nowrap;

	}

	.queue-alias-autoscroll {
		display: inline-block;
		animation: none;
	}

	.queue-alias-autoscroll[style*="--scroll-offset"] {
		animation: dynamic-peek var(--animation-duration, 6s) ease-in-out infinite;
	}

	.incall {
		font-size: smaller;
		font-weight: bold;
		background-color: #2a95b1;
		color: white;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		padding: 2px 10px 2px 10px;
		flex-wrap: wrap;

		.call-info {
			display: flex;
			gap: 10px;
		}

		.call-icons {
			display: flex;
			gap: 5px;
			align-items: center;

			.ringing-icon {
				color: darkblue;
			}
		}
	}

	.available {
		font-size: small;
		font-weight: bold;
		background-color: #aaa;
		border-radius: 10px;
	}

	.paused {
		font-size: small;
		font-weight: bold;
		background-color: #c2b049;
		color: white;
		border-radius: 10px;
	}

	.unpaused {
		font-size: small;
		font-weight: bold;
		background-color: #71a17c;
		color: white;
		border-radius: 10px;
	}

	.cursor-help {
		cursor: help;
	}

	.bg-pause {
		background-color: #c2b049 !important;
	}

	.bg-active {
		background-color: #287228
	}
}

.table-footer {
	display: flex;
	justify-content: space-between;
	margin: 10px;

	.per-page-selector {
		display: flex;
		gap: 5px;
		white-space: nowrap;
		border-radius: 10px;
		box-shadow: 1px 1px 3px gray;
		font-weight: bold;
		padding-left: 5px;
		transition: 0.3s;
		background-color: #1c869a;
		color: white;

		span {
			align-content: center;
			font-weight: bold;
		}

		select {
			border-radius: 0 10px 10px 0 !important;
			cursor: pointer;
		}
	}
}

::v-deep(.page-link) {
	font-weight: bold;
	border: none;
	border-radius: 10px !important;
	padding: 5px 10px;
	transition: 0.3s;
	margin: 2px;
	background-color: transparent;

	&:hover {
		background-color: #1c859a85;
	}
}

::v-deep(.page-link[aria-checked="true"]) {
	background-color: #1c869a;
}

::v-deep(.page-link[aria-checked="false"]) {
	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to next page"]) {
	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to previous page"]) {
	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to first page"]) {
	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to last page"]) {
	color: #1c869a;
}


@keyframes dynamic-peek {

	0%,
	25% {
		transform: translateX(0);
	}

	50%,
	75% {
		transform: translateX(var(--scroll-offset, -40%));
	}

	100% {
		transform: translateX(0);
	}
}

.action-container {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: repeat(2, 1fr);
	gap: 4px;
	opacity: 0.4;
	transition: ease-in-out 0.6s;

	div {
		padding: 5px;
		border-radius: 15px;
		font-size: 12px;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-shadow: 0px 1px 2px 1px lightgray;

		&:hover {
			box-shadow: 0px 1px 2px 1px gray;
			opacity: 0.8;
		}
	}

	#login-button {
		background-color: #cf2626;
		color: white;
	}

	#logout-button {
		background-color: #287228;
		color: white;
	}

	#pause-button {
		background-color: #c2b049;
		color: white;
	}

	#hangup-button {
		background-color: #d55b5b;
		color: white
	}

	#pickup-button {
		background-color: #1c869a;
		color: white;
	}

	#spy-button {
		background-color: #d59a4c;
		color: white;
	}

	#whisper-button {
		background-color: #46958d;
		color: white;
	}

	.disabled-button {
		background-color: gray !important;
		color: white !important;
		box-shadow: unset !important;
		opacity: 1 !important;
		cursor: not-allowed !important;
	}
}

::v-deep(tr:hover .action-container) {
	opacity: 1;
	transition: opacity 0.3s ease;
}
</style>